import { isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_PAYMENTS=true in .env.local for the local API.
export const PAYMENTS_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_PAYMENTS
);

/**
 * Payment states with no further answer coming; anything else is still worth
 * re-polling. Mirrors TERMINAL_INVOICE_PAYMENT_STATUSES in the API's
 * invoice-payment model — the two must agree or a settled payment reads as
 * still running.
 */
export const TERMINAL_PAYMENT_STATUSES = [
  'SETTLED',
  'REJECTED',
  'CANCELLED',
  'EXPIRED',
];

/**
 * Invoice payments are in a closed pilot. This list only hides the Pay button;
 * the API enforces the same set server-side (INVOICE_PAYMENT_PILOT_USER_IDS in
 * 3-API constants — keep the two in sync). Delete both when the pilot opens up.
 */
export const INVOICE_PAYMENT_PILOT_USER_IDS = [
  'eu-west-1:c1b4d047-f39d-45e9-aa5a-145b8ef88fd2', // Kalle
];
